import { Alert, Button, Dropdown, MenuProps, Popconfirm, Progress, Select, SelectProps, Space, notification } from 'antd'
import { Col, Row } from 'react-bootstrap'
import { Customer } from '../../model/Customer'
import {Dispatch, SetStateAction, useState} from 'react'
import { DownOutlined } from '@ant-design/icons';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import MarkEmailUnreadOutlinedIcon from '@mui/icons-material/MarkEmailUnreadOutlined';
import { Dayjs } from 'dayjs';
import 'dayjs/plugin/isoWeek'
import { isMobile } from 'react-device-detect';
import { MessageResponseDTO } from '../../model/ResponsesDTO';
import { ProviderValue, useAxios } from '../../config/axios-config';
import { MessageRequestDTO } from '../../model/MessageRequestDTO';
import { LocalDate } from 'local-date';
import { SendToRequest } from '../../model/SendToRequest';
import { SendStream } from '../util/SendStream';

export const SendToComponent : React.FC<{ options : SelectProps['options'],
                                          filteredCustomersList : Customer[],
                                          pickedDate : Dayjs,
                                          sendStream : SendStream,
                                          customerIdsList : number[],
                                          setCustomerIdsList : Dispatch<SetStateAction<number[]>>
                                        }> = (props) =>  {

  const {options, filteredCustomersList, pickedDate,
    sendStream, customerIdsList, setCustomerIdsList} = props
  const [open, setOpen] = useState(false);
  const [choice, setChoice] = useState<any>();
  const key = 'updatable';
  const controller = new AbortController();
  const signal = controller.signal
  const axiosInstance = useAxios() as ProviderValue

  const items: MenuProps['items'] = [
    {
      label: 'Wyślij email do wszystkich',
      key: 'send-email-to-all',
      icon: options === undefined || options?.length < 1 ? <HighlightOffIcon /> : <EmailOutlinedIcon />,
      disabled: options === undefined || options?.length < 1,
    },
    {
      label: 'Wyślij email do wybranych',
      key: 'send-email-to-selected',
      icon: customerIdsList.length < 1 ? <HighlightOffIcon /> : <MarkEmailUnreadOutlinedIcon/>,
      disabled: customerIdsList.length < 1,
    },
    {
      type: 'divider',
    },
    {
      label: 'Wyślij podsumowanie na mój adres email',
      key: 'send-backup',
      icon: options === undefined || options?.length < 1 ? <HighlightOffIcon /> : <EmailOutlinedIcon />,
      disabled: options === undefined || options?.length < 1 
    },
  ];

  const openNotification = (progress : number, showErrorMessage : boolean) => {
    notification.open({
      key: key,
      message: 'Status wysyłki',
      description:
      <>
        <Progress percent={progress} status={showErrorMessage ? "exception" : progress === 100 ? "success" : "normal"}/>
        {showErrorMessage && <Alert className='my-2' message="Błąd! Niektóre maile nie zostały wysłane. Zostały one automatycznie dodane 
              na listę do wysyłki selektywnej - możesz przejrzeć kto nie otrzymał maila i spróbować powtórzyć 
              wysyłkę wybierając globalną akcję 'Wyślij email do wybranych' lub skontaktować się z administratorem." 
              type="error" 
              showIcon={false} />}
      </>,
      duration: 0,
    });
  };

  const handleSend = async (sendToRequest : SendToRequest) => {
    const {receiversList, initialValueOfUnsentEmails, isBackup, stream} = sendToRequest

    let uuidList : number[] = receiversList !== undefined ? receiversList.map(customer => customer.customerid!) : []

    if (uuidList.length > 0) {
      let customerMealRequest = new MessageRequestDTO(uuidList, new LocalDate(pickedDate.startOf('month').format('YYYY-MM-DD')), stream)
      await axiosInstance.post<MessageResponseDTO>(`/messages/secure/sendmonthly${isBackup ? `backup` : ``}`, customerMealRequest, {signal}).then((response) => {
        let unsentList : number[] = response.data.unsentCustomerids
        setCustomerIdsList(isBackup ? [] : unsentList)
        openNotification(Math.floor(parseFloat(((initialValueOfUnsentEmails - unsentList.length)/initialValueOfUnsentEmails)
          .toFixed(2))*100), unsentList.length > 0)
      }).catch((e) => {
        console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
      }).then(() => {
        setTimeout(() => {
          notification.destroy()
        },1000*10)
      })
    } else {
      console.log("No customers picked")
    }
    
    return () => {
      controller.abort()
    }
  }

  const handleMenuClick = () => {
    openNotification(0, false)
    switch (choice.key) {
      case 'send-email-to-selected':
        let pickedCustomers = filteredCustomersList.filter(customer => customerIdsList.includes(customer.customerid!))
        handleSend(new SendToRequest(pickedCustomers, pickedCustomers.length, false, sendStream))
        break
      case 'send-backup':
        handleSend(new SendToRequest(filteredCustomersList, filteredCustomersList.length, true, sendStream))
        break
      default:
        let filteredNotEmpty = filteredCustomersList.filter(customer => customer.email !== 'Brak')
        handleSend(new SendToRequest(filteredNotEmpty, filteredNotEmpty.length, false, sendStream))
    }
    
    setChoice(undefined)
    setOpen(false)
  };
  
  const menuProps = {
    items,
    onClick: (e : any) => {setChoice(e); setOpen(true)},
    style: { width: '100%'},
  };
    return (
      <>
        {isMobile ?
        <>
          <Dropdown menu={menuProps} className={'mb-1'}>
              <Popconfirm
                title="Wysyłka maili"
                description="Czy jesteś pewien, że chcesz wykonać tę akcję?"
                open={open}
                onConfirm={handleMenuClick}
                onCancel={() => {setOpen(false); setChoice(undefined)}}
              >
                <Button style={{ width: '100%', justifyContent: 'center'}}>
                <Space style={{ width: '100%', justifyContent: 'center', color: 'gray'}}>
                  Wybierz akcję
                </Space>
                <DownOutlined style={{color: 'rgba(0, 0, 0, 0.25)'}}/>
                </Button>
              </Popconfirm>
            </Dropdown>
        <Select
                  mode="multiple"
                  allowClear
                  placeholder="Wybierz rodziców"
                  value={customerIdsList}
                  onChange={(e) => setCustomerIdsList(e)}
                  style={{ width: '100%', height : '100%', padding: '0' }}
                  options={options}

              />
        </>
        :
        <>
        <Col>
        <Row className={'customRow'} 
            style={{ alignItems: "center" }}
            align={'middle'} 
            type="flex"
            justify="center"
            gutter={10}>
            <Col>Globalne akcje:</Col>
            <Col>
            <Dropdown menu={menuProps}>
              <Popconfirm
                title="Wysyłka maili"
                description="Czy jesteś pewien, że chcesz wykonać tę akcję?"
                open={open}
                onConfirm={handleMenuClick}
                onCancel={() => {setOpen(false); setChoice(undefined)}}
              >
                <Button style={{ width: '100%', justifyContent: 'center'}}>
                <Space style={{ width: '100%', justifyContent: 'center', color: 'gray'}}>
                  Wybierz akcję
                </Space>
                <DownOutlined style={{color: 'rgba(0, 0, 0, 0.25)'}}/>
                </Button>
              </Popconfirm>
            </Dropdown>
            </Col>
        </Row>
        </Col>
        <Col>
          <Select
                    mode="multiple"
                    allowClear
                    placeholder="Wybierz rodziców, którym chcesz wysłać wiadomość."
                    value={customerIdsList}
                    onChange={(e) => setCustomerIdsList(e)}
                    style={{ width: '100%', height : '100%' }}
                    options={options}

                />
        </Col>
        </>
        }
      </>
    )
}